import axios from 'axios';
import doFileDownload from 'common-vue/triggerFileDownloadFromBlob';

export const instance = axios.create({
    baseURL: process.env.VUE_APP_PUBLIC_PATH
});

export const ebpInstance = axios.create({
    baseURL: process.env.VUE_APP_PUBLIC_PATH
});

export const createInstance = () =>
    axios.create({
        baseURL: process.env.VUE_APP_PUBLIC_PATH
    });

export const get = (url, config) => instance({ url, ...config });

instance.interceptors.response.use(
    r => r,
    error => {
        /*eslint-disable no-console*/
        console.error('response error', error.response);
        const data = error.response.data;
        //AjaxResult
        if (data.success === false) {
            return Promise.resolve(error.response);
        }
        return Promise.reject(error);
    }
);

export const fileDownload = async (opt, filename) => {
    if (!opt.url) {
        throw new Error('Please provide url for download');
    }
    const response = await ebpInstance({
        method: 'POST',
        ...opt,
        ...{ responseType: 'blob' }
    });

    return doFileDownload(response, filename);
};

export const fileUpload = async (url, formData, opt) => {
    return ebpInstance.post(url, formData, {
        headers: { 'Content-Type': 'multipart-form-data' },
        ...opt
    });
};

ebpInstance.interceptors.response.use(
    function(response) {
        if (response.headers['content-disposition']) {
            return response;
        }
        return response.data ? response.data : response;
    },
    async function(err) {
        /* eslint-disable no-console */
        console.error('ajax error', err.response);
        if (
            err.response.status === 403 &&
            (!err.response.data || err.response.data.errorId === undefined)
        ) {
            if (window.appRouter) {
                window.appRouter.push('/logout');
            }
        }
        if (err.response.data) {
            let data = err.response.data;
            if (data.errorId) {
                console.error('server error with errorId: ', data.errorId);
            }
            return data;
        }
        return {
            success: false,
            dataMap: {
                errors: { server: 'Server Error' },
                error: err
            }
        };
    }
);
